export const ACTIONS = {
  SORT: 'SORT',
  INITIALIZE_SORT: 'INITIALIZE_SORT'
};
